// Pivote PURO de un batch de liquidación por DUEÑO (cliente/planta). Sin React.
// El reparto ya viene calculado y congelado por el backend (admin-billing-liquidations.md,
// Q-114): cada línea trae shares[] = { owner:{id,name}|null, is_planta, percent_snapshot,
// share_amount }. Acá SOLO agrupamos/sumamos esos share_amount autoritativos para verlos por
// cliente (decisión 0001: el front no deriva dinero, solo reagrupa lo que el backend calculó).
//
// Devuelve: [{ client:{id,name}|null, is_planta, cows:[{ animal, percent, lines:[{ management, days,
// day_rate, pension, amount }], subtotal }], total }] ordenado por `total` desc, con la planta (residuo
// contable) siempre al final. `pension` = pensión total de la línea (vaca-manejo) · `amount` = la parte
// de ESTE dueño (share congelado). Ambos autoritativos del backend.

const PLANTA_KEY = '__planta__';

export function pivotBatchByClient(liquidations = []) {
    const groups = new Map(); // key -> { client, is_planta, cows: Map, total }

    for (const l of liquidations) {
        for (const s of (l.shares || [])) {
            const isPlanta = s.is_planta || !s.owner;
            const key = isPlanta ? PLANTA_KEY : String(s.owner.id);

            let g = groups.get(key);
            if (!g) {
                g = {
                    client: isPlanta ? null : { id: s.owner.id, name: s.owner.name },
                    is_planta: isPlanta,
                    cows: new Map(),
                    total: 0,
                };
                groups.set(key, g);
            }

            const animalKey = l.animal?.id ?? `x${l.id}`;
            let cow = g.cows.get(animalKey);
            if (!cow) {
                // El % de propiedad es por vaca (congelado): se toma del primer share visto.
                cow = { animal: l.animal, percent: s.percent_snapshot, lines: [], subtotal: 0 };
                g.cows.set(animalKey, cow);
            }

            const amount = Number(s.share_amount) || 0;
            cow.lines.push({ management: l.management?.name, days: l.days, day_rate: l.day_rate_snapshot, pension: l.pension_amount, amount: s.share_amount });
            cow.subtotal += amount;
            g.total += amount;
        }
    }

    return [...groups.values()]
        .map((g) => ({ client: g.client, is_planta: g.is_planta, cows: [...g.cows.values()], total: g.total }))
        .sort((a, b) => (a.is_planta !== b.is_planta ? (a.is_planta ? 1 : -1) : b.total - a.total));
}
